import dayjs from "dayjs";

/**
 * Formats a date string to DD-MM-YYYY hh:mm:ss A format (12-hour with AM/PM)
 * @param dateString - The date string to format (e.g., "2025-12-04 15:39:11")
 * @returns Formatted date string (e.g., "04-12-2025 3:39:11 PM") or "-" if invalid
 */

export const formatDateTime = (dateString: string | null | undefined): string => {
    if (!dateString) return "-";

    try {
        const date = dayjs(dateString);
        if (!date.isValid()) return "-";

        const formattedDate = date.format("DD-MM-YYYY");
        const formattedTime = date.format("h:mm:ss A");
        return `${formattedDate} ${formattedTime}`;
    } catch (error) {
        return "-";
    }
};

